
import { BeaconPlano } from 'interiores-mapa/dist/beaconPlano';

export class Encuesta {
	nombreEncuesta: string;
	formulacionPregunta: string;
	formulacionRespuesta: string;
	tipoPregunta: string;
	usuario: string;
	fecha: Date;
	rango: any;
	ENTIDAD: any;

    constructor(){}

	fromENTIDAD(ENTIDAD: any): Encuesta{

		this.ENTIDAD = ENTIDAD;
		this.nombreEncuesta = this.ENTIDAD.nombreEncuesta;
		this.formulacionPregunta = this.ENTIDAD.formulacionPregunta;
		this.formulacionRespuesta = this.ENTIDAD.formulacionRespuesta;
		this.tipoPregunta = this.ENTIDAD.tipoPregunta;
		this.usuario = this.ENTIDAD.usuario;
		this.fecha = this.ENTIDAD.fecha;
		if(this.ENTIDAD.tipoPregunta === 1){
			this.rango = Array(Number(this.ENTIDAD.formulacionRespuesta)).fill(1).map((x,i)=>i)
		}else{
			this.rango = [];
		}
		


		return this;
	}
}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Encuesta.ts